import { createSlice } from "@reduxjs/toolkit";
import { empresa } from "../../models/empresas/empresas.models";

export interface EmpresasState {
    empresas: empresa[]
};

const estadoInicial: EmpresasState = {
    empresas: []
};

const usuariosSlice = createSlice({
    name: "empresas",
    initialState: estadoInicial,
    reducers: {
        guardarEmpresas: (state, action) => {
            state.empresas = action.payload;
        }
    }
});

export const { guardarEmpresas } = usuariosSlice.actions;

export default usuariosSlice.reducer;
